export const localization = {
  en: {
    viewingHealthRecordFor: 'Viewing health record of',
    viewingAppointmentsOf: 'Viewing appointments of'
  },
  es: {
    viewingHealthRecordFor: 'Exploración del expediente clínico de',
    viewingAppointmentsOf: 'Citas de'
  },
  keyMapping: {
    // eslint-disable-next-line no-secrets/no-secrets -- localization key, not a secret
    viewingHealthRecordFor: 'UFD_Viewing_Health_Record',
    viewingAppointmentsOf: 'UFD_Viewing_Appts_Text'
  }
}
